import type { ReactNode } from 'react';
import { TableCell, TableRow, Typography } from '@mui/material';

import type { FoldedPayer, PayerAudience } from '../types';

import { StateChip } from './StateChip';

export interface PayerRowProps {
  payer: FoldedPayer;
  audience?: PayerAudience;
  /**
   * The action cell's content. AC-7 (the "Open in Stedi" / "Submit first
   * claim" links) is GDN-3406's to wire — this component only renders
   * whatever it's given, or nothing.
   */
  action?: ReactNode;
}

/**
 * One row of the clinic Payer Connections table (AC-6): payer name, folded
 * state chip, "what's happening" text, and an action slot. Presentational
 * only — expects a `<TableBody>` ancestor.
 */
export function PayerRow({ payer, action, audience }: PayerRowProps) {
  return (
    <TableRow>
      <TableCell sx={{ fontWeight: 500 }}>{payer.payerName}</TableCell>
      <TableCell>
        <StateChip state={payer.state} audience={audience} />
      </TableCell>
      <TableCell>
        <Typography sx={{ fontSize: '13px', color: 'text.secondary' }}>
          {payer.whatsHappening}
        </Typography>
      </TableCell>
      <TableCell align="right">{action}</TableCell>
    </TableRow>
  );
}
